import { putHIDetails } from "../services/healthInformation.service";
import { NotificationToaster } from "../utils/notificationToaster";

const updateHIDetails = (clientId, data) => (dispatch, getState) => {
  const { hiDetails } = getState().wizard;

  data.diagnosis = !!data.diagnosis ? data.diagnosis.trim() : "";
  data.allergies = !!data.allergies ? data.allergies.trim() : "";
  const payload = {
    userID: clientId,
    ...data,
  };

  if (
    hiDetails?.diagnosis !== payload?.diagnosis ||
    hiDetails?.allergies !== payload?.allergies
  ) {
    return putHIDetails(payload)
      .then(() => {
        dispatch({ type: "UPDATE_HI_DETAILS", payload: data });
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch({ type: "UPDATE_HI_ERROR", payload: err.message });
        NotificationToaster({ message: "Something went wrong", type: "error" });
      });
  } else {
    return Promise.resolve();
  }
};

export { updateHIDetails };
